module.exports = __webpack_public_path__ + "img/news0.b7cab484.png";